var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankNotebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.37,
    y: 74.16,
    width: 86.12,
    height: 114.83,
    fill: "#808390"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.9,
    y: 88.54,
    width: 86.12,
    height: 114.83,
    transform: "translate(144.78 -57.63) rotate(45)",
    fill: "#ededf2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.57,125.86l-15.34-15.34a14.32,14.32,0,1,0-4.65,4.73l15.3,15.3ZM96.35,103.14A7.66,7.66,0,1,1,104,110.8,7.66,7.66,0,0,1,96.35,103.14Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "168.18 47.18 165.89 43.2 160.38 46.38 160.38 40.02 155.79 40.02 155.79 46.38 150.28 43.2 147.99 47.18 153.49 50.35 147.99 53.53 150.28 57.51 155.79 54.33 155.79 60.69 160.38 60.69 160.38 54.33 165.89 57.51 168.18 53.53 162.68 50.35 168.18 47.18",
    fill: "#4877ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.71,
    y: 142.82,
    width: 63.15,
    height: 6.89,
    fill: "#808390"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.71,
    y: 155.45,
    width: 50.52,
    height: 6.89,
    fill: "#808390"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.71,
    y: 168.08,
    width: 42.49,
    height: 6.89,
    fill: "#808390"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.71,
    y: 180.71,
    width: 58.56,
    height: 6.89,
    fill: "#808390"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankNotebook);
export default __webpack_public_path__ + "static/media/blank_notebook.c6d8cf9c9f5cc435173fc643383f0f9a.svg";
export { ForwardRef as ReactComponent };